import { logoutUser } from '~/clientApis/userApi';
import { showMessageModal } from '~/clientUtils/showMessageModal';
import { getStore } from '~/mobx/AppStore';

const logout = async () => {
    const { userStore } = getStore();
    userStore.setIsLoggingOut(true);
    try {
        await logoutUser();
    } catch {
        showMessageModal('error', 'Failed to logout. Please try again.');
    } finally {
        userStore.setUser(null);
    }
    userStore.setIsLoggingOut(false);
};

export default logout;
